import { useState } from "react";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const AMOUNTS = [5, 10, 20];

export const TipJar = ({ className = "" }) => {
  const [busy, setBusy] = useState(null);

  const tip = async (amount) => {
    setBusy(amount);
    try {
      const { data } = await api.post("/tips/checkout", { amount, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(apiError(e));
      setBusy(null);
    }
  };

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="tip-jar">
      {AMOUNTS.map((a) => (
        <Button key={a} variant="outline" disabled={busy !== null} onClick={() => tip(a)}
          data-testid={`tip-${a}-btn`} className="rounded-full px-6">
          <Heart size={13} className="mr-2 text-primary" /> {busy === a ? "Opening…" : `$${a}`}
        </Button>
      ))}
    </div>
  );
};
